function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M41.27 6.86h-38a2 2 0 010-4h38a2 2 0 010 4zm-36 4h30a2 2 0 010 4h-30a2 2 0 010-4zm12 8h22a2 2 0 010 4h-22a2 2 0 110-4zm2 16h6a2 2 0 010 4h-6a2 2 0 110-4zm1-6a2 2 0 012-2h14a2 2 0 010 4h-14a2 2 0 01-2-2z"
});

var SvgTornado = function SvgTornado(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 44.8 40.84",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTornado, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tornado.f2b73cb5.svg";
export { ForwardRef as ReactComponent };